import { Card, Box, Icon } from '@nimbus-ds/components';
import { ChevronRightIcon } from '@nimbus-ds/icons';
import { LocationSelector } from 'domains/Catalog/components';
import { useTranslationCatalog } from 'domains/Catalog/hooks';

interface SourceDestinationCardProps {
  sourceLocationId?: string;
  destinationLocationId?: string;
  onSelectSource: (locationId: string) => void;
  onSelectDestination: (locationId: string) => void;
  disabledSource?: boolean;
  disabledDestination?: boolean;
}

function SourceDestinationCard({
  sourceLocationId,
  destinationLocationId,
  onSelectSource,
  onSelectDestination,
  disabledSource,
  disabledDestination,
}: Readonly<SourceDestinationCardProps>) {
  const t = useTranslationCatalog();

  return (
    <Card>
      <Card.Header title={t('transfers.new.sourceDestination.title')} />
      <Card.Body>
        <Box
          display="flex"
          gap={{ xs: '2', md: '4' }}
          flexDirection={{ xs: 'column', md: 'row' }}
          alignItems="flex-start"
        >
          <Box flex={{ md: '1' }}>
            <LocationSelector
              selectedLocationId={sourceLocationId}
              label={t('transfers.new.sourceDestination.source.label')}
              placeholder={t(
                'transfers.new.sourceDestination.source.placeholder',
              )}
              showPrefix={false}
              showAddress
              onSelectionChange={onSelectSource}
              disabled={disabledSource}
            />
          </Box>

          <Box alignSelf="center" display={{ xs: 'none', md: 'block' }}>
            <Icon source={<ChevronRightIcon />} color="neutral-textLow" />
          </Box>

          <Box flex={{ md: '1' }}>
            <LocationSelector
              selectedLocationId={destinationLocationId}
              label={t('transfers.new.sourceDestination.destination.label')}
              placeholder={t(
                'transfers.new.sourceDestination.destination.placeholder',
              )}
              showPrefix={false}
              showAddress
              showWhenJustOneLocation
              disabled={disabledDestination}
              excludeLocationId={disabledSource ? sourceLocationId : undefined}
              onSelectionChange={onSelectDestination}
            />
          </Box>
        </Box>
      </Card.Body>
    </Card>
  );
}

export default SourceDestinationCard;
